/**
 * Blessed Sportswear — Scroll Reveal
 * IntersectionObserver-based fade-up animation for product cards,
 * pillars, testimonials, and section content blocks.
 */
(function initScrollReveal() {
  if (typeof IntersectionObserver === 'undefined') return;

  const SELECTORS = [
    '.product-card',
    '.blessed-pillar',
    '.blessed-testimonial-item',
    '.blessed-brand-story__inner',
    '.blessed-stat',
    '.blessed-collection-panel',
    '.blessed-proof-band__logo',
  ];

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
  );

  function observe() {
    const elements = document.querySelectorAll(SELECTORS.join(','));
    elements.forEach((el, i) => {
      if (!el.classList.contains('scroll-reveal')) {
        el.classList.add('scroll-reveal');
        // Stagger delay: max 0.5s so later items don't feel broken
        el.style.transitionDelay = Math.min(i % 8, 7) * 0.06 + 's';
      }
      observer.observe(el);
    });
  }

  // Run on DOMContentLoaded and again after any dynamic section renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // Re-run when Shopify theme editor adds/removes sections
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', observe);
  }
})();
